import {
  Box,
  Button,
  Container,
  Paper,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useState } from "react";

// Layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Step components
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";

function AddClinic() {
  const [activeStep, setActiveStep] = useState(0);
  const [formData, setFormData] = useState({});

  const steps = ["Personal Info", "Services", "Locations"];

  // Unified next handler for all steps
  const handleNext = (dataFromStep = {}) => {
    setFormData((prev) => ({ ...prev, ...dataFromStep }));

    setActiveStep((prev) => {
      if (prev < steps.length - 1) {
        return prev + 1;
      }
      return prev; // Prevent going beyond last step
    });
  };

  // Render the component for each step
  const getStepComponent = () => {
    switch (activeStep) {
      case 0:
        return <Step1 onNext={handleNext} />;
      case 1:
        return <Step2 val={formData} onNext={handleNext} />;
      case 2:
        return <Step3 val={formData} onNext={handleNext} />;
      default:
        return (
          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="h5" gutterBottom>
              All steps completed – you're finished!
            </Typography>
            <Typography variant="body1">
              Thank you! The clinic has been added successfully.
            </Typography>
          </Box>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Container maxWidth="md" sx={{ mt: 4 }}>
        {activeStep < steps.length && (
          <Typography variant="h4">{`Step ${activeStep + 1}: ${steps[activeStep]}`}</Typography>
        )}
        <Paper elevation={3} sx={{ p: 3, mt: 2 }}>
          <Stepper activeStep={activeStep}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <Box sx={{ mt: 3 }}>{getStepComponent()}</Box>
        </Paper>
      </Container>
    </DashboardLayout>
  );
}

export default AddClinic;
